import React, { useRef } from 'react';
import useDuperbrowseLink from '../../../../../Duperbrowse/hooks/useDuperbrowseLink';
import getBiDataForDeviationLink from '../../../../../Duperbrowse/DeviationLink/getBiDataForDeviationLink';
import Button from '../../../../../Button';
import { getDeviationUrl } from '../../../../_helpers';
import s from './PollDuperbrowseLink.scss';
/*
  Using our own component-specific component here instead of modifying DeviationLink
  to accept an arbitrary component due to some small if statements in DeviationLink's
  definition not playing well with the data on polls. Modifying DeviationLink will
  take more effort to assure no regressions occur than just creating this small component.
*/
var PollDuperbrowseLink = function (_a) {
    var deviation = _a.deviation, children = _a.children;
    var ref = useRef();
    var onDuperbrowseClick = useDuperbrowseLink(deviation.deviationId, ref);
    return (React.createElement(Button, { href: getDeviationUrl(deviation, false), view: "b14", onClick: onDuperbrowseClick, className: s['button'], biData: getBiDataForDeviationLink(deviation) }, children));
};
PollDuperbrowseLink.displayName = 'PollDuperbrowseLink';
export default PollDuperbrowseLink;
//# sourceMappingURL=PollDuperbrowseLink.js.map